module.exports = {"pageTitleText":"服務管理"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/appProfileSetting.json
// module id = zwJj
// module chunks = 3